module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"no_one_has_written_yet":"暂无用户对此商品进行评价。","no_one_who_has_type_has_written_yet_html":"暂无{userPropertyTypeOptionName} 类型用户对此商品进行评价。","should_write_review":"成为首位评价该商品的用户吧！","write_review":"撰写评论"}}')
  delete Component.options._Ctor
}
